import Axios from '../Axios';

const Zone = {
	create(data) {
		return Axios.post('/meters', data);
	},
	read(limit = 10, page = 1, search) {
		return Axios.get('/meters?&limit=' + limit + '&page=' + page + search);
	},
	readOne(id) {
		return Axios.get('/meters/' + id);
	},
	update(id, data) {
		return Axios.put('/meters/' + id, data);
	},
	delete(id) {
		return Axios.delete('/meters/' + id);
	},
};

export default Zone;
